import React from 'react'
import { getClient } from '../client'
import { groqSanityPageQuery, propsSanity } from '../lib/libFunctions'
import StandardContentPage from '../components/standard-content-page/standard-content-page.component'

export default function EditorialPolicyPage({ page }) {
  return (
    <StandardContentPage
      page={page}
      heroCtaHref="/contact"
      heroCtaLabel="Submit a correction"
    />
  )
}

export async function getServerSideProps() {
  const data = await getClient().fetch(groqSanityPageQuery('editorial-policy'), {})

  if (!data?.length) return { notFound: true }

  return {
    props: {
      page: propsSanity(data),
    },
  }
}
